export default __webpack_public_path__ + "static/media/gas.ca6a454a.svg";